export default "__VITE_ASSET__DSQhJsK9__"